<template>
  <v-row>
    <v-col cols="6">
      <!-- 顧客名 -->
      <MultipleSelectCustomerName v-model="inputedValue" />
    </v-col>
    <v-col cols="6"> </v-col>
  </v-row>
</template>

<script>
import { MultipleSelectCustomerName } from '@/components/items/Selectboxes'

export default {
  components: {
    MultipleSelectCustomerName
  },
  props: {
    value: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
